import { APIBinderData } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';
import { processValidation, validateFailedObjects } from '../utils/helpers';

export const processMVRLicenseStatusData = (
  binderReportData: APIBinderData,
  validation?: Validation,
): BinderSectionData => {
  const mvrData = binderReportData?.mvr_data || [];

  const driverRows = mvrData.map((driver, index: number) => {
    const isValid = validateFailedObjects(index, validation);

    return {
      name: driver?.name,
      status: driver?.status || 'Unknown',
      isValid,
    };
  });

  const validationData = processValidation(validation);

  return {
    title: 'MVR License Status',
    description: 'Review MVR license information and status for all drivers.',
    isValid: validationData.isValid,
    message: validationData.message,
    data: {
      drivers: driverRows,
    },
  };
};
